module.exports = __webpack_public_path__ + "img/offre_complete.b95841d6.webp";